import { Badge } from '@/components/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { Lead } from '@/types/leads'
import { LEAD_PRIORITY_LABELS, LEAD_SOURCE_LABELS, LEAD_STAGE_LABELS } from '@/types/leads'
import { formatLeadValue, leadCreatedAgo } from './lead-format'

interface LeadsListViewProps {
  leads: Lead[]
  onLeadClick: (lead: Lead) => void
}

/** Leads em lista (todos os estágios, inclusive arquivados); a linha abre a ficha. */
export function LeadsListView({ leads, onLeadClick }: LeadsListViewProps) {
  if (leads.length === 0) return <p className="py-6 text-center text-sm text-muted-foreground">Nenhum lead encontrado.</p>
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nome</TableHead>
          <TableHead>Estágio</TableHead>
          <TableHead className="hidden md:table-cell">Contato</TableHead>
          <TableHead className="hidden lg:table-cell">Origem</TableHead>
          <TableHead className="hidden sm:table-cell">Prioridade</TableHead>
          <TableHead className="hidden lg:table-cell text-right">Valor</TableHead>
          <TableHead className="hidden md:table-cell">Criado</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {leads.map((lead) => (
          <TableRow key={lead.id} className="cursor-pointer" onClick={() => onLeadClick(lead)}>
            <TableCell>
              <button
                type="button"
                className="text-left font-medium hover:underline"
                onClick={(e) => {
                  e.stopPropagation()
                  onLeadClick(lead)
                }}
              >
                {lead.name}
              </button>
              {lead.companyName && <span className="block text-xs text-muted-foreground">{lead.companyName}</span>}
            </TableCell>
            <TableCell>
              <Badge variant="outline">{LEAD_STAGE_LABELS[lead.stage] ?? lead.stage}</Badge>
            </TableCell>
            <TableCell className="hidden md:table-cell text-muted-foreground">{lead.email || lead.whatsapp || '—'}</TableCell>
            <TableCell className="hidden lg:table-cell">{LEAD_SOURCE_LABELS[lead.source] ?? lead.source}</TableCell>
            <TableCell className="hidden sm:table-cell">{LEAD_PRIORITY_LABELS[lead.priority] ?? lead.priority}</TableCell>
            <TableCell className="hidden lg:table-cell text-right tabular-nums">{formatLeadValue(lead.estimatedValue) ?? '—'}</TableCell>
            <TableCell className="hidden md:table-cell text-muted-foreground">{leadCreatedAgo(lead)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
